import { TableSessionEvent } from './types';
import { handleOrderItemUpdatedEvent, OrderItemUpdatedType } from './orderItemUpdated.handler';

export function manageEvent(event: TableSessionEvent): void {
	switch (event.type) {
		case 'ORDER_UPDATED':
			handleOrderItemUpdatedEvent(event as OrderItemUpdatedType);
			break;
		default:
			break;
	}
}
